// src/posts/postsIndex.js
// Simple in-repo posts. (We can switch to Markdown later.)
export const posts = [
  {
    slug: "hello-world",
    title: "Hello, World — Blog Kickoff",
    date: "2025-10-24",
    summary: "A tiny first post to begin my bloging saga",

    contentHtml: `
      <p>Welcome! This is a minimal blog post rendered from a plain JS object.
      Later, we can load Markdown and render it at build-time.</p>
    `
  },
  {
    slug: "how to Ads-In in Fusion 360ß",
    title: "Notes on creating an Ads-In",
    date: "2025-10-20",
    summary: "Quick bullets about how to ship a pkg for Fusion 360 users.",
    
    contentHtml: `
      <ul>
        <li>Working on pkg creation.</li>
      </ul>
    `
  }
];
